import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'

export function useTaskNotifications() {
  const { user } = useAuth()
  const [unreadCount, setUnreadCount] = useState(0)

  const fetchCount = async () => {
    if (!user) return
    const { count } = await supabase
      .from('task_notifications')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', user.id)
      .is('seen_at', null)
    setUnreadCount(count ?? 0)
  }

  const markAllSeen = async () => {
    if (!user) return
    await supabase
      .from('task_notifications')
      .update({ seen_at: new Date().toISOString() })
      .eq('user_id', user.id)
      .is('seen_at', null)
    setUnreadCount(0)
  }

  useEffect(() => {
    if (!user) return
    fetchCount()
    const channel = supabase
      .channel(`task-notifications-${user.id}`)
      .on('postgres_changes', {
        event: '*',
        schema: 'public',
        table: 'task_notifications',
        filter: `user_id=eq.${user.id}`,
      }, fetchCount)
      .subscribe()
    return () => supabase.removeChannel(channel)
  }, [user?.id])

  return { unreadCount, markAllSeen, refetch: fetchCount }
}
